<template>
  <!-- copilot begin -->
  <div class="customer-service-wrapper">
    <!-- 右下角客服悬浮按钮 -->
    <div
      class="customer-service-btn"
      @click="openCustomerService"
      title="在线客服">
      <i class="el-icon-service btn-icon"></i>
      <span class="btn-text">在线客服</span>
    </div>

    <!-- 右下角客服小窗口 Dialog -->
    <el-dialog
      title="在线客服"
      :visible.sync="dialogVisible"
      width="720px"
      custom-class="customer-service-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="handleClose">
      <div class="iframe-container" v-loading="loading">
        <iframe
          v-if="serviceUrl"
          :src="serviceUrl"
          frameborder="0"
          class="service-iframe"
          @load="iframeLoaded">
        </iframe>
      </div>
    </el-dialog>
  </div>
  <!-- copilot end -->
</template>

<script>
// copilot begin
import Cookies from 'js-cookie';

export default {
  name: 'CustomerService',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      serviceUrl: '',
    };
  },
  methods: {
    openCustomerService() {
      const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO') || '{}');
      const fromUser = loginInfo.merchantId || loginInfo.userId || loginInfo.agentId || localStorage.getItem('userId') || (this.$store.state.user && this.$store.state.user.userId) || '';
      const userName = loginInfo.username || loginInfo.userName || loginInfo.merchantName || localStorage.getItem('userName') || (this.$store.state.user && this.$store.state.user.name) || '';
      const sessionId = loginInfo.sessionId || Cookies.get('sessionId') || '';
      const t = Date.now();

      // 拼接客服链接
      this.serviceUrl = `https://mgt-crm.leshuazf.com/webchatclient/#/?appid=2901&fromuser=${fromUser}&t=${t}&merchantId=${fromUser}&username=${encodeURIComponent(userName)}&userName=${encodeURIComponent(userName)}&sessionId=${sessionId}`;

      this.loading = true;
      this.dialogVisible = true;
    },
    iframeLoaded() {
      this.loading = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
// copilot end
</script>

<style lang="scss" scoped>
/* copilot begin */
.customer-service-btn {
  position: fixed;
  right: 20px;
  bottom: 60px;
  z-index: 1900;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 46px;
  padding: 16px 0;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-radius: 23px;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.35);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  user-select: none;

  &:hover {
    transform: translateY(-4px) scale(1.04);
    box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
  }

  &:active {
    transform: translateY(-1px) scale(0.98);
  }

  .btn-icon {
    margin-bottom: 8px;
    font-size: 20px;
    transition: transform 0.3s ease;
  }

  &:hover .btn-icon {
    transform: rotate(-10deg) scale(1.1);
  }

  .btn-text {
    display: block;
    width: 1em;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 1px;
    text-align: center;
    word-break: break-all;
  }
}

.iframe-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f8fafc;

  .service-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
/* copilot end */
</style>

<style lang="scss">
/* copilot begin */
.customer-service-dialog {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  bottom: 60px !important;
  left: auto !important;
  width: 720px !important;
  max-width: calc(100vw - 40px) !important;
  height: calc(100vh - 80px) !important;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  overflow: hidden;
  border-radius: 16px !important;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.22) !important;

  @media screen and (max-width: 768px) {
    right: 12px !important;
    left: 12px !important;
    width: auto !important;
    max-width: none !important;
  }

  .el-dialog__header {
    flex-shrink: 0;
    padding: 14px 20px;
    margin: 0;
    background: #fff;
    border-bottom: 1px solid #f1f5f9;

    .el-dialog__title {
      font-size: 15px;
      font-weight: 600;
      line-height: 20px;
      color: #1e293b;
    }
  }

  .el-dialog__headerbtn {
    top: 10px;
    right: 12px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(226, 232, 240, 0.8);
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(8px);
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

    .el-dialog__close {
      font-size: 16px;
      font-weight: 600;
      color: #475569;
      transition: transform 0.3s ease, color 0.3s ease;
    }

    &:hover {
      background: #2563eb;
      border-color: #2563eb;

      .el-dialog__close {
        color: #ffffff;
        transform: rotate(90deg);
      }
    }
  }

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    padding: 0;
  }
}
/* copilot end */
</style>
